package ld;

import ld.Types.Vec2;
import tweenx909.TweenX;
import tweenxcore.Tools.Easing;
import pixi.core.sprites.Sprite;
import stocking.AudioManager;
import pixi.core.textures.Texture;

class SpecialAbility
{
	public var range: Int;
	public var name: String;
	public var owner: Pawn;

	public function new( owner : Pawn )
	{
		this.owner = owner;
	}

	public function execute( target: Vec2, ?onComplete: Void->Void )
	{
		//owner.bCanAttack = false;
		owner.bCanAbility = false;
	}

	public function canTarget( target: Vec2 )
	{
		return  Util.AbsDistance( owner.position, target ) <= range;
	}

	public static function getSpecial( a: String, owner: Pawn ) : SpecialAbility
	{
		switch(a)
		{
			case "vine_pull":
				return new SpecialAttackPull(owner);
			case "dive_bomb":
				return new SpecialAttackDiveBomb(owner);
			case "web":
				return new SpecialAbilityWeb(owner);
			case "gun":
				return new SpecialAttackGun(owner);
			case "bomb":
				return new SpecialAttackBomb(owner);
			case "whack":
				return new SpecialAttackWhack(owner);
		}

		return null;
	}

}

class SpecialAttackPull extends SpecialAbility
{
	public function new( owner : Pawn )
	{
		super( owner );
		this.name = "Vine pull";
		this.range = 4;
	}

	public override function canTarget( target: Vec2 )
	{
		var victim = owner.scene.map.GetPawnForPosition( target );
		
		if( victim == null )
		{
			return false;
		}

		return super.canTarget(target);
	}
	
	public override function execute( target: Vec2, ?onComplete: Void->Void )
	{
		if( !owner.bCanAbility )
			return;

		var victim = owner.scene.map.GetPawnForPosition( target );
		if( victim == null )
		{
			trace(" ???? ");
		}

		// Determine the closest free tile
		owner.scene.map.configureForPawn(victim);
		var path = owner.scene.map.getRouteToPawn(target, owner );
		trace(path);
		if( path == null || path.length < 2 )
		{
			trace ("WOMP.");
			return;
		}
		path.pop();
		var targetTile = path.pop();

		victim.position.x = targetTile.x;
		victim.position.y = targetTile.y;

		var sprite = new Sprite(Texture.fromImage("assets/Vine FX.png"));
		sprite.anchor.y = 1.0;
		sprite.x = 44;
		victim.container.addChild(sprite);

		var targetCoord = Util.TileToCoord(targetTile);
		super.execute( target, null );
		AudioManager.instance.play("assets/sfx/Inventory_Open_00.wav", function(){
			AudioManager.instance.play("assets/sfx/Inventory_Open_01.wav");
		});

		TweenX.to( victim.container, {x: targetCoord.x, y: targetCoord.y }).time(0.8).ease(Easing.elasticIn).onFinish(function(){
			if( onComplete != null )
				onComplete();

			TweenX.to( sprite, {alpha: 0 }).time(0.3).onFinish(function(){
				victim.container.removeChild(sprite);
			});
			
		});

	

		
	}
}


class SpecialAttackDiveBomb extends SpecialAbility
{
	public function new( owner : Pawn )
	{
		super( owner );
		this.name = "Dive bomb";
		this.range = 8;
	}

	public override function canTarget( target: Vec2 )
	{
		var victim = owner.scene.map.GetPawnForPosition( target );
		
		if( victim != null && victim != owner )
		{
			return false;
		}

		return super.canTarget(target);
	}
	
	public override function execute( target: Vec2, ?onComplete: Void->Void )
	{
		if( !owner.bCanAbility || !canTarget(target) )
			return;

		owner.position = target;
		owner.bCanAbility = false;
		owner.bCanAttack = false;
		owner.bCanMove = false;
		var targetCoord = Util.TileToCoord(target);

		var sprite = new Sprite(Texture.fromImage("assets/Bird_Drop_FX.png"));
		sprite.anchor.y = 1.0;
		sprite.x = -90;
		sprite.y = 30;
		

		AudioManager.instance.play("assets/sfx/Inventory_Open_01.wav");
		TweenX.to( owner.container, {y: owner.container.y - 300 }).time(0.7).ease(Easing.cubicOut).onFinish(function(){


			TweenX.to( owner.container, {x: targetCoord.x, y: targetCoord.y }).time(0.3).ease(Easing.expoIn).onFinish(function(){
				AudioManager.instance.play("assets/sfx/hit37.wav");
				// Target nearby tiles
				for( x in (target.x - 1)...(target.x + 2) )
				{
					for( y in (target.y - 1)...(target.y + 2) )
					{
						trace(x,y);
						var victim = owner.scene.map.GetPawnForPosition( {x:x, y:y} );
						if( victim != null && victim != owner  )
						{
							victim.takeDamage(5);
						}
					}
				}

				owner.container.addChild(sprite);
				sprite.alpha = 0;

				TweenX.to( sprite, {alpha: 1 }).time(0.1).ease(Easing.expoIn).onFinish(function(){
					TweenX.to( sprite, {alpha: 0 }).time(1).onFinish(function(){
						owner.container.removeChild(sprite);
					});
				});
				
				if( onComplete != null )
					onComplete();
			});
		});

		

		
	}
}


class SpecialAbilityWeb extends SpecialAbility
{
	public function new( owner : Pawn )
	{
		super( owner );
		this.name = "Web";
		this.range = 3;
	}

	public override function canTarget( target: Vec2 )
	{
		var victim = owner.scene.map.GetPawnForPosition( target );

		if( victim != null )
		{
			return false;
		}

		return super.canTarget(target);
	}
	
	public override function execute( target: Vec2, ?onComplete: Void->Void )
	{
		if( !owner.bCanAbility || !canTarget(target) )
			return;

		owner.bCanAbility = false;

		var targetCoord = Util.TileToCoord(target);
		var sprite = owner.scene.map.AddWeb(target);

		sprite.x = owner.container.x;
		sprite.y = owner.container.y - 128;

		AudioManager.instance.play("assets/sfx/hit11.wav");

		TweenX.to( sprite, {x: targetCoord.x, y: targetCoord.y }).time(0.7).ease(Easing.cubicOut).onFinish(function(){
	
				
			if( onComplete != null )
				onComplete();
		});
		

		

		
	}
}

class SpecialAttackGun extends SpecialAbility
{
	public function new( owner : Pawn )
	{
		super( owner );
		this.name = "Gun";
		this.range = 6;
	}

	public override function canTarget( target: Vec2 )
	{
		var victim = owner.scene.map.GetPawnForPosition( target );

		
		if( victim == null )
		{
			return false;
		}
		

		return super.canTarget(target);
	}
	
	public override function execute( target: Vec2, ?onComplete: Void->Void )
	{
		if( !owner.bCanAbility || !canTarget(target) )
			return;

		var victim = owner.scene.map.GetPawnForPosition( target );
		if( victim == null )
		{
			trace(" ??????!?!! ");
		}

		trace("BANG");
		AudioManager.instance.play("assets/sfx/378204__eflexthesounddesigner__semi-auto-rifle-shot-open-field-mixed.wav");

		owner.bCanAbility = false;

		var targetCoord = Util.TileToCoord(target);
		var sprite = new Sprite(Texture.fromImage("assets/Bullet_FX.png"));

		sprite.x = owner.container.x;
		sprite.y = owner.container.y ;
		owner.scene.containerField.addChild(sprite);
		owner.scene.CenterOn(victim, function(){
			TweenX.to( sprite, {x: targetCoord.x, y: targetCoord.y }).ease(Easing.linear).time(0.1).onFinish(function(){
				victim.takeDamage(4);
				owner.scene.containerField.removeChild(sprite);
				if( onComplete != null )
					onComplete();
			});		
		});
	}
}


class SpecialAttackBomb extends SpecialAbility
{
	public function new( owner : Pawn )
	{
		super( owner );
		this.name = "Bomb";
		this.range = 99; // FUCK YOU I'VE GOT AN F-14
	}

	public override function canTarget( target: Vec2 )
	{
		var victim = owner.scene.map.GetPawnForPosition( target );

		
		if( victim == null )
		{
			return false;
		}
		

		return super.canTarget(target);
	}
	
	public override function execute( target: Vec2, ?onComplete: Void->Void )
	{
		if( !owner.bCanAbility || !canTarget(target) )
			return;

		var victim = owner.scene.map.GetPawnForPosition( target );
		if( victim == null )
		{
			trace(" ??????!?!! ");
		}

		
		

		owner.bCanAbility = false;

		var targetCoord = Util.TileToCoord(target);
		var sprite = new Sprite(Texture.fromImage("assets/bomv FX.png"));
		sprite.anchor.y = 1.0;
		sprite.x = victim.container.x;
		sprite.y = victim.container.y;
		sprite.scale.y = 0;
		sprite.alpha = 0;
		owner.scene.containerField.addChild(sprite);
		owner.scene.CenterOn(victim, function(){
			AudioManager.instance.play("assets/sfx/33245__ljudman__grenade.wav");

			TweenX.to( sprite, {alpha: 1 }).time(0.3).ease(Easing.expoIn);
			TweenX.to( sprite.scale, {y: 2 }).time(1.0).ease(Easing.bounceOut).onFinish(function(){
				
				victim.takeDamage(9);
				
				if( onComplete != null )
					onComplete();

				TweenX.to( sprite, {alpha: 0 }).time(1).ease(Easing.quadInOut).onFinish(function(){

					owner.scene.containerField.removeChild(sprite);
				});
					
			});	
		});
	
	}
}

class SpecialAttackWhack extends SpecialAbility
{
	public function new( owner : Pawn )
	{
		super( owner );
		this.name = "Whack";
		this.range = 1;
	}

	public override function canTarget( target: Vec2 )
	{
		var victim = owner.scene.map.GetPawnForPosition( target );

		
		if( victim == null )
		{
			return false;
		}
		

		return super.canTarget(target);
	}
	
	public override function execute( target: Vec2, ?onComplete: Void->Void )
	{
		if( !owner.bCanAbility || !canTarget(target) )
			return;

		var victim = owner.scene.map.GetPawnForPosition( target );
		if( victim == null )
		{
			trace(" ??????!?!! ");
		}

		
		

		owner.bCanAbility = false;

		var targetCoord = Util.TileToCoord(target);
		var sprite = new Sprite(Texture.fromImage("assets/WHACK FX.png"));
		sprite.anchor.y = 1.0;
		sprite.x = victim.container.x - 32;
		sprite.y = victim.container.y;
		sprite.scale.x = 0;
		sprite.alpha = 0;
		owner.scene.containerField.addChild(sprite);
		owner.scene.CenterOn(victim, function(){
			AudioManager.instance.play("assets/sfx/hit09.wav");

			TweenX.to( sprite, {alpha: 1 }).time(0.3).ease(Easing.expoIn);
			TweenX.to( sprite.scale, {x: 1 }).time(0.5).ease(Easing.expoOut).onFinish(function(){
				
				victim.takeDamage(13);
				victim.stun();
				
				if( onComplete != null )
					onComplete();

				TweenX.to( sprite, {alpha: 0 }).time(1).ease(Easing.quadInOut).onFinish(function(){

					owner.scene.containerField.removeChild(sprite);
				});
					
			});	
		});
	
	}
}